export default "__VITE_ASSET__CuoCqRrM__"